module.exports = __webpack_public_path__ + "static/media/currency_rupee_black_circle.99ea0c31.svg";